import { CalendarClock, CheckCircle2, ClipboardList } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useMyCampaigns } from '@/api/queries/campaigns-queries'
import { AdminCardPage } from '@/components/commons'
import { ROUTES } from '@/constants/routes'
import { formatLocalDate } from '@/utils/campaign-dates'

/** Campanhas abertas para a pessoa logada (qualquer perfil); o link de cada uma também pode ser compartilhado. */
export const CampaignsPage = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { data: campaigns, isLoading, isError } = useMyCampaigns()

	return (
		<AdminCardPage
			icon={<ClipboardList className="size-5" />}
			title={t('campaigns.title')}
			subtitle={t('campaigns.subtitle')}
			onBack={() => navigate(ROUTES.DASHBOARD.HOME)}
		>
			{isLoading ? (
				<p className="py-16 text-center text-muted-foreground text-sm">
					{t('common.loading')}
				</p>
			) : isError ? (
				<p className="py-16 text-center text-destructive text-sm">
					{t('campaigns.loadError')}
				</p>
			) : !campaigns?.length ? (
				<p className="py-16 text-center text-muted-foreground text-sm">
					{t('campaigns.empty')}
				</p>
			) : (
				<div className="grid grid-cols-1 gap-3 md:grid-cols-2">
					{campaigns.map((campaign) => {
						const answered = campaign.myResponses > 0
						return (
							<button
								key={campaign.id}
								type="button"
								onClick={() =>
									navigate(
										ROUTES.DASHBOARD.CAMPAIGN_DETAIL.replace(
											':id',
											campaign.id,
										),
									)
								}
								className="flex flex-col gap-2 rounded-lg border border-kaefer-light-silver bg-white p-4 text-left shadow-sm transition-shadow hover:shadow-md"
							>
								<div className="flex items-start justify-between gap-2">
									<h3 className="font-semibold text-kaefer-dark-grey">
										{campaign.title}
									</h3>
									{answered && (
										<span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-kaefer-forest-green/15 px-2 py-0.5 text-xs font-semibold text-kaefer-forest-green">
											<CheckCircle2 className="size-3.5" />
											{t('campaigns.answered')}
										</span>
									)}
								</div>
								{campaign.description && (
									<p className="line-clamp-2 text-sm text-muted-foreground">
										{campaign.description}
									</p>
								)}
								<div className="mt-auto flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
									<span>
										{t('campaigns.questionCount', {
											count: campaign.questionCount,
										})}
									</span>
									{campaign.endsAt && (
										<span className="inline-flex items-center gap-1">
											<CalendarClock className="size-3.5" />
											{t('campaigns.until', {
												date: formatLocalDate(campaign.endsAt),
											})}
										</span>
									)}
								</div>
							</button>
						)
					})}
				</div>
			)}
		</AdminCardPage>
	)
}
